import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AuthManagementService} from '@core/service/auth-management.service';
import {UnsubscribeOnDestroyAdapter,} from '@shared';
import {UsersComponent} from "../admin/users/users.component";
import {PatientListComponent} from "../patient/patient-list/patient-list.component";
import {UserRole} from "@core/models/Enums/UserRole";
import {
  PatientMyPrescriptionsComponent
} from "../patient/patient-list/patient-my-prescriptions/patient-my-prescriptions.component";
import {GuidedTourService} from "@core/service/guided-tour.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [
    UsersComponent,
    PatientListComponent,
    PatientMyPrescriptionsComponent,
  ],
})
export class DashboardComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  userRole: string = ''
  control = 'dashboard'
  protected readonly UserRole = UserRole;

  constructor(
    private authManagement: AuthManagementService,
    private guidedTour: GuidedTourService,
  ) {
    super();
  }

  ngOnInit() {
    const userData = this.authManagement.userData();
    this.userRole = userData.TipoUsuario;
  }
}
